import React, { memo } from "react";
import { TableHead, TableHeadProps } from "@mui/material";
import AppTableRow from "./AppTableRow";

const AppTableHead = ({ children, ...otherProps }: TableHeadProps) => {
  return <TableHead {...otherProps}>{children}</TableHead>;
};

export default memo(AppTableHead);
